import React, {
  useMemo,
  FC,
}                       from 'react';
import styled           from 'styled-components';
import * as Yup         from 'yup';
import {
  Formik,
  FormikConfig,
}                       from 'formik';
import { Breakpoint }   from '@material-ui/core/styles/createBreakpoints';
import {
  ICardAd,
  ICardAdValues,
}                       from '@typings/nationalAdManagement';
import { EAdType }      from '@enums/nationalAdManagement';
import { AdEditorForm } from './AdEditorForm';

const Wrapper = styled.div`
  margin           : 0 auto;
  background-color : ${({ theme: { backgroundColor } }): string => backgroundColor.white};
`;

const validationSchema: Yup.Schema<ICardAdValues> = Yup.object().shape<ICardAdValues>({
  id          : Yup.string(),
  image       : Yup.mixed(),
  type        : Yup.mixed().oneOf([0, 1, 2]).required(),
  isActive    : Yup.boolean().required(),
  isClickable : Yup.boolean().required(),
  title       : Yup.string()
    .when('type', {
      is        : (value): boolean => value === EAdType.GraphicOnlyAd,
      then      : Yup.string().max(30),
      otherwise : Yup.string().max(30).required(),
    }),
  body: Yup.string()
    .when('isClickable', {
      is        : true,
      then      : Yup.string().max(135),
      otherwise : Yup.string().max(225),
    }),
  link: Yup.string()
    .when('isClickable', {
      is        : true,
      then      : Yup.string().max(255).required(),
      otherwise : Yup.string().max(255),
    }),
  buttonName: Yup.string()
    .when('isClickable', {
      is        : true,
      then      : Yup.string().max(25).required(),
      otherwise : Yup.string().max(25),
    }),
});

const getInitialValues = (adData: ICardAd | null): ICardAdValues => ({
  id          : adData?.id,
  type        : adData?.type ?? EAdType.TextAndGraphicAd,
  title       : adData?.title ?? '',
  body        : adData?.body ?? '',
  link        : adData?.link ?? '',
  buttonName  : adData?.buttonName ?? '',
  isActive    : adData?.isActive ?? true,
  isClickable : adData?.isClickable ?? true,
});

interface IAdEditorFormProps extends Pick<FormikConfig<ICardAdValues>, 'onSubmit'>{
  width    : Breakpoint;
  adData   : ICardAd | null;
  onCancel : () => void;
}

export const AdEditorWrapper: FC<IAdEditorFormProps> = ({
  width,
  adData,
  onSubmit,
  onCancel,
}) => {
  const initialValues = useMemo<ICardAdValues>(
    () => getInitialValues(adData),
    [adData],
  );

  return  (
    <Wrapper>
      <Formik
        onSubmit         = {onSubmit}
        initialValues    = {initialValues}
        validationSchema = {validationSchema}
      >
        <AdEditorForm
          width    = {width}
          onCancel = {onCancel}
          logoUrl  = {adData?.imageUrl}
        />
      </Formik>
    </Wrapper>
  );
};
